<template>
  <el-dialog :title="mytitle" :visible.sync="dialogFormVisible" custom-class="list-dialog" center :append-to-body="true"
             :close-on-click-modal="false" @close="onDialogClose"
  >
    <div class="search-content write-order">
      <el-row>
        <el-row>
          <el-col :span="24" class="toobar">
            <el-col :span="5">
              <AutoCustomer ref="autocustomer" @handleSelect="select" :splitByAddress="true"  :needfocus="true"></AutoCustomer>
            </el-col>
            <!--<div style="float: right;width: 1411px;">-->
            <el-col :span="18" v-if="customerserial">
              <el-select v-model="cangkucode" @change="changeCangKu"  style="width: 130px;display: block;margin: auto;float: left;margin-left: 30px;">
                <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                           :label="item.cangkuname"
                           :value="item.cangkucode">
                </el-option>
              </el-select>
              <CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindData"
                          :isShowCheckBox="false" :treeWidth="550"
                          style="width: 200px;display: block;margin: auto;float: left;margin-left: 30px;"
                          :onlyShowGroupType="false" :needTopNode="false" :onlySelectChild="true" :selectpingpai="true"
                          :treeHeight="500" :searchText="seedname"
                          @check="checktree1"></CommonTree>
              <el-input v-model="tracknum" ref="tracknum" placeholder="供应商单号" @change="tracknumsubmit" clearable
                        v-if="mytitle!='门店下单'"
                        onfocus="this.select()"
                        style="width: 110px"></el-input>
              <el-input v-model="logisticstracknum" ref="logisticstracknum" placeholder="跟踪号" clearable
                        v-if="mytitle!='门店下单'"
                        @change="logisticstracknumsubmit"
                        onfocus="this.select()"
                        style="width: 110px"></el-input>
              <el-button type="success" @click.stop.prevent="addGood()">增加</el-button>
              <el-button type="success" @click.stop.prevent="showGoodDetailSel()" v-if="filltemplates=='80'">选择</el-button>
              <!--<el-button size="mini" type="warning" @click.stop.prevent="jinjiatuihuo()">退货申请</el-button>-->
            </el-col>
            <!--</div>-->
          </el-col>
        </el-row>
        <el-row>
          <div style="float: left;margin-top: 8px;font-size: larger;margin-left: 5px"  v-if="deliveryaddress==''?false:true"> 门店：<span>{{this.deptname}}</span>&nbsp;&nbsp;收货地址：<span>{{this.deliveryaddress}}</span>
          </div>
        </el-row>
      </el-row>
      <el-row>

      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <iframe width="100%" scrolling="Auto" id="iframe" ref="iframe" :height="tableHeight(130)" frameborder="0" name="writeorder1" @click="isshow"></iframe>
        </el-col>
      </el-row>
    </div>
    <BatchBuyFormProperties ref="batchBuyFormProperties" @afterSelectCode="afterSelectCode"></BatchBuyFormProperties>
    <MakeInventoryFrameAdd ref="MakeInventoryFrameAdd" @afterSelect="afterSelect"></MakeInventoryFrameAdd>
    <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode" @afterCloseDialog="afterSelectCode" :isShowCheckBox="true" :showtree="false"></JxcgooddetailSel>
    <HsCstagreementList ref="HsCstagreementList"></HsCstagreementList>
  </el-dialog>


</template>

<script>
  import BatchBuyFormProperties from '../buyagreement/BatchBuyFormProperties'
  import {getListData, deleteData} from '@/api/set/externaldept';
  import {independentDept} from '@/api/set/dept';
  import {simulationLogin,checkModuleRight} from '@/api/login';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import HsCstagreementList from './HsCstagreementList';
  import {getGoodsTree, listgoodsframe} from '@/api/set/jxcgooddetail';
  import MakeInventoryFrameAdd from '../../warehouse/MakeInventoryFrameAdd';
  import JxcgooddetailSel from '@/components/set/jxcgooddetail/JxcgooddetailSel';

  export default {

    name: 'WriteFrameReturnOrder',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        dialogFormVisible: false,
        searchdata: "",
        myunitgroup: this.unitgroup,
        mytitle: this.title,
        loading: true,
        servedserial: "",
        idd: [],
        tableData: [],
        filltemplates:'80',
        pinyinData: [],
        coupon: '',
        province: '',//省
        city: '',//市
        county: '',//县
        fengongscangku:false,
        couponServedserial: '',//独立核算
        deliveryaddress: '',//收货地址
        deptname: '',
        loginName: '',
        customerserial: '',
        restaurants: [],
        timeout: null,
        elinkman: '',
        elinkmantel: '',
        canshowgoodsel: true,//解决清空事件与click的冲突问题
        seedcode: '',
        seedname: '',
        jxcstoreData: [],//仓库数组
        cangkucode: '',//选中的仓库
        cangkuname: '',
        roletype: '',//岗位类型
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        seedcodeData: [],//选择类别后的商品
        totalnumber: 0,//总数量
        btnupdatevisible: false,//防止重复提交
        settingmenthod: '',//付款方式
        arr: [],
        thiswindow: null,
        myToken: '',//选中客户后记录的 token（多窗口防串客户：检测到 token 变了就关闭开单窗口）
        sessionCheckTimer: null,//防串客户轮询定时器（关闭对话框时注销）
      }
    },
    props: {
      unitgroup: {
        default: 1
      },
      title: {
        default: "客户信息"
      },
      parentcustomerserial: {//上级客户编码
        default: ""
      },
      filterbyservedserial: {//根据当前登录人所属的加工中心过滤数据
        default: false
      },
      storeInfo: {
        default: ""
      }
    },
    methods: {
      jinjiatuihuo() {
        if (!this.customerserial) {
          this.$message.error("请先选择门店");
          return
        }
        window.open(window.location.origin + "/H5/html/DaiFaHuo/dingDan/dingDan_main.html", 'writeorder1', false)
      },
      //ifame点击删除后调用的方法
      del(data) {
        if (data) {
          this.tableData = []
          this.tableData = JSON.parse(JSON.stringify(data))

        }
      },
      addGood(){
        if(this.filltemplates=='40'){
          window.open(window.location.origin + "/#/app/emptyVue" , 'writeorder1',false)
          this.$refs.JxcgooddetailSel.setFilltemplate(40);
          this.$refs.JxcgooddetailSel.setCategorycode(this.seedcode);
          this.$refs.JxcgooddetailSel.showBind()
        }else {
          if (this.seedcodeData.length == 0) {
            this.$message.error("请先选择商品分类");
            return
          }
          window.open(window.location.origin + "/#/app/emptyVue" , 'writeorder1',false)
          this.$refs.MakeInventoryFrameAdd.show(this.seedcodeData, {
            cangkucode: this.cangkucode,
            cangkuname: this.cangkuname
          })
        }
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.seedcodeData.length == 0) {
          this.$message.error("请先选择商品分类");
          return
        }
        for (let i in this.seedcodeData) {
          this.seedcodeData[i].totalnumber = 0
        }
        //参数  false 不显示库存，seedcode分类，cangkucode 仓库，seedcodeData 分类下的商品

        window.open(window.location.origin + "/#/app/emptyVue" , 'writeorder1',false)
        this.$refs.batchBuyFormProperties.initData(true, this.seedcode, this.cangkucode, this.seedcodeData)
      },
      //删除明细
      handleDelete(index, row) {
        this.tableData.splice(index, 1)
      },
      //iframe 子类调用的方法（退货成功后用）
      isshow() {
        this.dialogFormVisible = false
        this.$emit("bindGrid")//刷新页面
      },
      tracknumsubmit() {
        localStorage.setItem('tracknum', this.tracknum.trim());
        this.$refs.logisticstracknum.focus()
      },
      logisticstracknumsubmit() {
        localStorage.setItem('logisticstracknum', this.logisticstracknum.trim());
      },
      //选择类别后执行的方法
      checktree1(guids, names, arr) {
        if (!this.customerserial) {
          this.$message.error("请先选择门店");
          return
        }
        this.seedcode = guids
        this.seedname = names
        this.seedcodeData = []
        if(!this.seedcode){
          return;
        }
        if(this.filltemplates=='40'){
          this.addGood();
          return;
        }

        listgoodsframe({
          needprice: '1',
          categorycode: this.seedcode,
          customerserial:this.customerserial,
          filltemplate: '80',
        }).then(response => {
          this.seedcodeData = response.data.obj
          if (this.seedcodeData.length > 0) {
            // 如果类别下只有一个商品且色号只有一个，直接自动选中（数量默认1）
            if (this.seedcodeData.length == 1) {
              var onlyGoods = this.seedcodeData[0];
              var colors = (onlyGoods.color || '').split(';').filter(c => c);
              if (colors.length == 1) {
                this.afterSelectCode([{
                  seedcode: onlyGoods.seedcode,
                  seedname: onlyGoods.seedname,
                  color: colors[0],
                  model: onlyGoods.model,
                  categorycode: onlyGoods.categorycode,
                  totalnumber: 1,
                  costprice: onlyGoods.costprice,
                  storenum: onlyGoods.storenum,
                  goodyear: onlyGoods.goodyear
                }]);
                return;
              }
            }
            //参数  false 不显示库存，seedcode分类，cangkucode 仓库，seedcodeData 分类下的商品
            // window.open(window.location.origin + "/#/app/emptyVue" , 'writeorder1',false)
            this.addGood();
            //this.$refs.batchBuyFormProperties.initData(true, this.seedcode, this.cangkucode, this.seedcodeData);
          } else {
            this.$message({
              message: '该系列没有镜架商品',
              type: 'warning'
            })
            return
          }
        }).catch((error) => {
          console.log(error)
        });

      },
      afterSelect(arr) {
        var selectArr = []
        for (var i in arr) {
          selectArr.push({
            seedcode: arr[i].seedcode,
            seedname: arr[i].seedname,
            color: arr[i].C,
            model: arr[i].M,
            categorycode: arr[i].categorycode,
            totalnumber: arr[i].P,
            storenum:arr[i].storenum,
            costprice:arr[i].costprice,
            goodyear:arr[i].goodyear
          });
        }
        this.afterSelectCode(selectArr);
      },
      //选择商品之后执行
      afterSelectCode(arr) {
        // 先从 iframe 同步最新的 tableData（用户在 iframe 里直接编辑的行不能丢）
        try {
          var iframeData = this.$refs.iframe.contentWindow.vueTableData;
          if (iframeData && iframeData.length > 0) {
            this.tableData = iframeData.map(item => ({
              seedcode: item.seedcode,
              seedname: item.seedname,
              color: item.color,
              model: item.model,
              categorycode: item.categorycode,
              totalnumber: parseInt(item.totalnumber),
              formproperty: item.formproperty || '[{}]',
              packagesize: item.packagesize || '',
              onlycode: item.onlycode || '',
              barcodes: item.barcodes || [],
              barcodesnum: item.barcodesnum || 0,
              costprice: item.costprice,
              storenum: item.storenum,
              goodyear: item.goodyear
            }));
          }
        } catch(e) { /* iframe 不可达时忽略 */ }
        //console.log(arr)
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          if (this.filltemplates == '40') {
            for (let j in this.tableData) {
              if (this.tableData[j].seedcode == arr[i].seedcode) {
                biaoji = 1
                count++;
                this.tableData[j].totalnumber += 1;
                break
              }
            }
            if (biaoji == 0) {
              this.tableData.push({
                seedcode: arr[i].seedcode,
                seedname: arr[i].seedname,
                categorycode: arr[i].categorycode,
                totalnumber: 1,
                formproperty: '[{}]',
                onlycode: '',
                barcodes: [],
                barcodesnum: 0,
                costprice:arr[i].costprice,
                storenum:arr[i].storenum,
                goodyear:arr[i].goodyear
              })
            }
          } else {
            //判读该商品是否属于
            for (let j in this.tableData) {
              if (this.tableData[j].seedcode == arr[i].seedcode && this.tableData[j].model == arr[i].model && this.tableData[j].color == arr[i].color) {
                biaoji = 1
                count++;
                this.tableData[j].totalnumber += parseInt(arr[i].totalnumber);
                break
              }
            }
            if (biaoji == 0) {
              this.tableData.push({
                seedcode: arr[i].seedcode,
                seedname: arr[i].seedname,
                color: arr[i].color,
                model: arr[i].model,
                categorycode: arr[i].categorycode,
                totalnumber: parseInt(arr[i].totalnumber),
                formproperty: '[{}]',
                packagesize: '{"M":"' + arr[i].model + '","C":"' + arr[i].color + '"}',
                onlycode: '',
                barcodes: [],
                barcodesnum: 0,
                costprice:arr[i].costprice,
                storenum:arr[i].storenum,
                goodyear:arr[i].goodyear
              })
            }
          }
        }
        localStorage.setItem('returnfilltem', this.filltemplates);
        localStorage.setItem('tableData', JSON.stringify(this.tableData));
        this.openURL = 'HsTuiHuoJingJiaApp'
        window.open(window.location.origin+ "/#/app/" + this.openURL+"?type=1", 'writeorder1',false)
      },
      bindData() {
        if(!this.$refs.treeSeed) return;
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({filltemplates: this.filltemplates, hideseed: '1'})
        })
      },
      //刷新按钮
      refreshBtn() {
        this.btnupdatevisible = false
      },
      //客户地址
      select(customerserial, customername, row) {
        this.deliveryaddress = row.deliveryaddress
        this.elinkman = row.linkman
        this.elinkmantel = row.linkmantel
        this.deptname = row.deptname
        this.customerserial = row.customerserial
        var settingmenthods = row.settingmenthod.split(',');
        this.settingmenthod=''
        for (let i = 0; i < settingmenthods.length; i++) {
          if (settingmenthods[i] == '全额现结') {
            settingmenthods[i] = 100
          } else if (settingmenthods[i] == '月结') {
            settingmenthods[i] = 200
          }
          if (this.settingmenthod) {
            this.settingmenthod = this.settingmenthod + ',' + settingmenthods[i]
          } else {
            this.settingmenthod = settingmenthods[i] + ''
          }
        }
        var initCangKu=row.servedserial;
        if(this.jxcstoreData.length>0) {
          this.cangkucode = this.jxcstoreData[0].cangkucode;
          if(this.fengongscangku) {
            for (let i in this.jxcstoreData) {
              if (this.jxcstoreData[i].independentserial == initCangKu) {
                this.cangkucode = this.jxcstoreData[i].cangkucode;
                break;
              }
            }
          }
          this.changeCangKu();
        }
        //客户信息
        simulationLogin({loginName: this.loginName, customerserial: this.customerserial}).then(response => {
          if (response.data.code == 0) {
            this.jxcstoreData.forEach(o => {
              if (o.cangkucode == this.cangkucode) {
                this.cangkuname = o.cangkuname
              }
            })
            localStorage.setItem('hpweb_token', response.data.token); //兼容vue端的相关页面
            localStorage.setItem('keFTtoken', response.data.token); //token
            localStorage.setItem('keFuInfoModel', JSON.stringify(response.data.obj)); //用户信息
            localStorage.setItem('domain', window.location.host);
            localStorage.setItem('deliveryaddress', this.deliveryaddress);
            localStorage.setItem('elinkman', this.elinkman);
            localStorage.setItem('elinkmantel', this.elinkmantel);
            localStorage.setItem('cangkucode', this.cangkucode);
            localStorage.setItem('cangkuname', this.cangkuname);
            localStorage.setItem('roletype', this.roletype);
            localStorage.setItem('settingmenthod', this.settingmenthod);
            localStorage.setItem('title', this.mytitle);
            if (this.mytitle == '门店下单') {
              //前台缓存使用
              if (localStorage.getItem('keFTtoken')) {
                localStorage.setItem('$state', JSON.stringify({'token': localStorage.getItem('keFTtoken')}));
                localStorage.setItem('keFuInfo', 'keFuInfo'); //作为判断是客服的操作，登录时会删除这个状态
              }
              if (localStorage.getItem('keFuInfoModel')) {
                var kuFuInfoModel = JSON.parse(localStorage.getItem('keFuInfoModel'));
                localStorage.removeItem('keFuInfoModel');
                window.localStorage.setItem('$xh_user', JSON.stringify({
                  'uguid': kuFuInfoModel.uguid,
                  'linkmantel': kuFuInfoModel.memberDO.linkmantel,
                  'uname': kuFuInfoModel.uname,
                  'md5password': '',
                  'TenantID': ''
                }));
                localStorage.setItem('deptname', kuFuInfoModel.tenantname); //缓存公司名称
                localStorage.setItem('uname', kuFuInfoModel.uname); //我的页面名称
                localStorage.setItem('mobile', kuFuInfoModel.memberDO.linkmantel); //我的页面名称kuFuInfoModel.mobile
                localStorage.setItem('status', kuFuInfoModel.status); //缓存账号类型判断是否能查看余额
                localStorage.setItem('uguid', kuFuInfoModel.uguid); //用于获取头像
                localStorage.setItem('tenantid', kuFuInfoModel.tenantid); //用于获取头像
                localStorage.setItem('linkmantel', kuFuInfoModel.memberDO.linkmantel); //与登录账号比较，是否显示子账号
                localStorage.setItem('servername', kuFuInfoModel.memberDO.servedname); //servername，服务商地址
                localStorage.setItem('currentlevel', "2"); //是否能支付 为2就是能支付
                localStorage.setItem('isRight', true);
                if (kuFuInfoModel.memberDO != null) {
                  window.localStorage.setItem('MUnitguid', kuFuInfoModel.memberDO.unitguid) //缓存Unitguid获取开票信息
                }
              }

            }

            //记录本次选中客户的 token：其他窗口选了别的客户会覆盖全局 localStorage，
            //切回本窗口时一旦发现 token 不一致就关闭当前开单窗口，避免串客户退货/下单
            this.myToken = response.data.token;

            this.afterSelectCode([])
          } else {
            this.$message({
              type: 'warning',
              duration: 1500,
              message: response.data.msg
            });
          }
        })
      },
      changeCangKu() {
        localStorage.setItem('cangkucode', this.cangkucode);
        this.jxcstoreData.forEach(o => {
          if (o.cangkucode == this.cangkucode) {
            this.cangkuname = o.cangkuname
          }
        })
        localStorage.setItem('cangkuname', this.cangkuname);
        try {
          window.writeorder.window.refreshErWeiTable()
        } catch (ee) {
        }
      },
      showdailog(groupguid) {
        this.$refs.HsCstagreementList.bindGrid(groupguid)
      },
      //【多窗口防串客户】每 1 秒检测一次全局 token：若已被其他页面改写（选了别的客户），
      //直接关闭当前开单窗口，避免客服继续用错误的客户退货/下单
      startSessionCheck() {
        this.stopSessionCheck();
        var self = this;
        var check = function () {
          if (!self.dialogFormVisible) {//对话框已关闭，停止检测
            self.sessionCheckTimer = null;
            return;
          }
          if (self.myToken && localStorage.getItem('hpweb_token') !== self.myToken) {
            self.$message({
              type: 'warning',
              duration: 3000,
              message: '检测到客户已在其他页面切换，当前开单窗口已关闭，请重新选择客户'
            });
            self.dialogFormVisible = false;
            self.sessionCheckTimer = null;
            return;
          }
          self.sessionCheckTimer = setTimeout(check, 1000);
        };
        this.sessionCheckTimer = setTimeout(check, 1000);
      },
      stopSessionCheck() {
        if (this.sessionCheckTimer) {
          clearTimeout(this.sessionCheckTimer);
          this.sessionCheckTimer = null;
        }
      },
      onDialogClose() {
        this.stopSessionCheck();
      },
      inittableData() {
        this.tableData = []
      },
      show(unitgroup, title, roletype,filltemp) {
        if (this.$refs.autocustomer) {
          this.$refs.autocustomer.clearContent();
        }

        if(filltemp==null) filltemp='80';
        if(filltemp!=this.filltemplates) {
          this.filltemplates = filltemp;
          this.bindData();
        }
        this.totalnumber = 0
        this.seedcodeData = []
        this.seedname = ''
        this.seedcode='';
        this.searchdata = ''//选中的门店
        this.deliveryaddress = ''//收货地址
        this.restaurants = []
        this.pinyinData = []
        this.coupon = ''
        this.province = ''//省
        this.city = ''//市
        this.county = ''//县
        this.couponServedserial = ''//独立核算
        this.roletype = ''
        this.logisticstracknum = ''
        this.tracknum = ''
        this.tableData = []
        this.customerserial='';
        this.myToken = ''//清空上次记录的 token，选中客户后重新记录
        this.startSessionCheck();//开始每秒检测全局 token 是否被其他页面改写
        if (unitgroup) {
          this.myunitgroup = unitgroup
        }
        if (title) {
          this.mytitle = title
        } else {
          this.mytitle = '退货单'
        }
        if (roletype) {
          this.roletype = roletype
        }
        this.dialogFormVisible = true
        if (this.storeInfo) {
          this.coupon = this.storeInfo.coupon
          this.province = this.storeInfo.province//省
          this.city = this.storeInfo.city//市
          this.county = this.storeInfo.county//县
          this.couponServedserial = this.storeInfo.independentserial//独立核算
        }
        if (this.$refs.autocustomer)
          this.$refs.autocustomer.init();

        this.cusandptbyind();
      },
      cusandptbyind() {
        //根据登录人过滤仓库
        cusandptbyind({}).then(response => {
          this.jxcstoreData = response.data.obj
          //默认仓库
          if (this.userInfoModel.cangku) {
            let temp1 = this.userInfoModel.cangku.split(";")
            biaoji:
              for (let i in temp1) {
                for (let j in  this.jxcstoreData) {
                  if (temp1[i] == this.jxcstoreData[j].cangkucode) {
                    this.cangkucode = temp1[i]
                    break biaoji;
                  }
                }
              }

          } else {
            this.cangkucode = this.jxcstoreData[0].cangkucode
          }
        })

      },

    },
    mounted() {
      window.showdailogjinjia = (groupguid) => {
        this.showdailog(groupguid)
      }
      window.inittableData = () => {
        this.inittableData()
      }
      checkModuleRight({name: 'fengongscangku'}).then(reponse => {
        this.fengongscangku = reponse.data.code == 0;
      });
      //将方法设置成全局方法，用来子页面调用
      window['del'] = (data) => {
        this.del(data)
      }
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.servedserial = this.userInfoModel.independentserial;
      //默认值
      if (!this.userInfoModel.independentserial) {
        independentDept().then(response => {
          this.idd = response.data.obj
          if (this.userInfoModel.independentserial == "") {
            this.idd.unshift({serialnum: "all", dname: "全部"})
            this.servedserial = 'all';
          }

        })
      }
    },
    beforeDestroy() {
      this.stopSessionCheck();
    },
    components: {
      BatchBuyFormProperties,
      HsCstagreementList,
      MakeInventoryFrameAdd,
      JxcgooddetailSel
    }

  }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

  .name {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .addr {
    font-size: 12px;
    color: #b4b4b4;
  }


</style>




// WEBPACK FOOTER //
// src/components/testorder/cstagreement/WriteFrameReturnOrder.vue